module.exports = __webpack_public_path__ + "static/img/is3.771c652.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institute/pic/is3.jpg
// module id = t1GJ
// module chunks = 11